import React, { useEffect, useState } from 'react';
import './CaWhoWeAre.css';

const CaWhoWeAre = ({ onOpenModal }) => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setRotation(scrollY * 0.15);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleBtnClick = (e) => {
    e.preventDefault();
    if (onOpenModal) {
      onOpenModal();
    }
  };

  return (
    <section
      className="Ca-who-we-are"
      id="about"
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')`
      }}
    >
      <div className="Ca-who-we-are__container">
        {/* Left Column: Overlapping Images */}
        <div className="Ca-who-we-are__images-wrapper">
          {/* Rotating Certified Stamp on Scroll */}
          <div
            className="Ca-who-we-are__stamp"
            style={{ transform: `rotate(${rotation}deg)` }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/G-3.webp`}
              alt="Certified Quran Academy Stamp"
              className="Ca-who-we-are__stamp-img"
            />
          </div>

          {/* Top Image */}
          <div className="Ca-who-we-are__img-container Ca-who-we-are__img-container--top">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/BG-3.jpg`}
              alt="Online Quran Classes For Kids"
              className="Ca-who-we-are__main-img"
            />
          </div>

          {/* Bottom Image */}
          <div className="Ca-who-we-are__img-container Ca-who-we-are__img-container--bottom">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/wmremove-transformed-2.jpeg`}
              alt="Online Quran Classes For Kids"
              className="Ca-who-we-are__main-img"
            />
          </div>
        </div>

        {/* Right Column: Text & Content */}
        <div className="Ca-who-we-are__content">
          <div className="Ca-who-we-are__subtitle">
            <svg aria-hidden="true" className="Ca-who-we-are__subtitle-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
            </svg>
            <span>Who We Are?</span>
          </div>

          <h2 className="Ca-who-we-are__title">
            The Best Online Quran Academy in Canada for Kids and Adults
          </h2>

          <p className="Ca-who-we-are__paragraph">
            For over a decade, Al Quran Lesson has delivered structured Quranic education to Muslim families living across Canada. We are not a marketplace of random teachers; we are a dedicated online Quran academy where every tutor is certified, graduated, and a specialized online Quran teacher. Every session is one-on-one, and every lesson plan is designed around your child’s or your own pace and goals.
          </p>

          <p className="Ca-who-we-are__paragraph">
            Our online Quran classes combine the authentic teaching standards of traditional Islamic scholarship with the convenience and reliability of modern virtual learning. Whether your child is starting from absolute zero or you are an adult looking to reconnect with the Quran, our online Quran academy in Canada is built to deliver measurable results, not just attendance.

          </p>

          <p className="Ca-who-we-are__paragraph">
            We offer male and female tutors, fully flexible scheduling built around you, and round-the-clock availability. Every student receives a personalized learning roadmap, regular progress reports, and a completion certificate upon finishing their course.
          </p>

          <ul className="Ca-who-we-are__list">
            <li className="Ca-who-we-are__list-item">
              <span className="Ca-who-we-are__list-bullet"></span>
              Certified Native Arabic Tutors
            </li>
            <li className="Ca-who-we-are__list-item">
              <span className="Ca-who-we-are__list-bullet"></span>
              24/7 Availability, Canadian Time Zone
            </li>
            <li className="Ca-who-we-are__list-item">
              <span className="Ca-who-we-are__list-bullet"></span>
              Completion Certificate for Every Course
            </li>
          </ul>

          <div className="Ca-who-we-are__contacts">
            <a href="tel:+16477385707" className="Ca-who-we-are__contact-item">
              <div className="Ca-who-we-are__contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="Ca-who-we-are__contact-svg">
                  <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27 11.72 11.72 0 003.7.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.7 1 1 0 01-.27 1.11z" />
                </svg>
              </div>
              <div className="Ca-who-we-are__contact-text">
                <span className="Ca-who-we-are__contact-label">Call Us Anytime</span>
                <span className="Ca-who-we-are__contact-value">647-738-5707</span>
              </div>
            </a>

            <a href="mailto:info@alquranlesson.com" className="Ca-who-we-are__contact-item">
              <div className="Ca-who-we-are__contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="Ca-who-we-are__contact-svg">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
              </div>
              <div className="Ca-who-we-are__contact-text">
                <span className="Ca-who-we-are__contact-label">Email Us Anytime</span>
                <span className="Ca-who-we-are__contact-value">info@alquranlesson.com</span>
              </div>
            </a>
          </div>

          <button onClick={handleBtnClick} className="Ca-who-we-are__btn">
            Book Your 3-Day Free Trial
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="Ca-who-we-are__btn-icon">
              <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CaWhoWeAre;
